import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { Box } from '@mui/material'
import theme from './theme'
import { application } from './data/info'
import ResponsiveAppBar from './components/layout/AppBar'
import Home from './components/sections/Home'
import About from './components/sections/About'
import Apply from './components/sections/Apply'
import Topics from './components/sections/Topics'
import Apps from './components/sections/Apps'
import StudentApps from './components/sections/StudentApps'
import Mentors from './components/sections/Mentors'
import Numbers from './components/sections/Numbers'
import Contact from './components/sections/Contact'
import popupImage from './resources/popup.jpg'

function App() {
  // useEffect(() => {
  //   if (application.applicationsOpen) {
  //     document.getElementById('show_modal').showModal()
  //   }
  // }, [])

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box>
          <ResponsiveAppBar />
          <section id="Home">
            <Home />
          </section>
          <section id="Sobre">
            <About />
          </section>
          <section id="Processo">
            <Apply />
            <Topics />
          </section>
          <section id="Apps">
            <StudentApps />
            <Apps />
          </section>
          <section id="Mentoria">
            <Mentors />
          </section>
          <Numbers />
          <section id="Contato">
            <Contact />
          </section>
        </Box>
      </ThemeProvider>
      {/* Popup do processo seletivo — descomentar quando as inscrições estiverem abertas
      <dialog id="show_modal" className="modal">
        <div className="modal-box p-0 max-h-[80vh] max-w-[66.5vh] m-5">
          <a href="./processo">
            <img src={popupImage} className="" alt="Inscreva-se no processo seletivo"></img>
          </a>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
      */}
    </>
  )
}

export default App
